import axios from "axios";

/**
 * Narrowed before indexing: not every failure is the API's own envelope — a gateway 502 replies
 * with HTML — and `in` throws on a string rather than returning false.
 */
export function isCampaignStateError(error: unknown, code: "composite_ad" | "advertisement_not_found"): boolean {
  if (!axios.isAxiosError(error)) {
    return false;
  }
  const data: unknown = error.response?.data;
  return typeof data === "object" && data !== null && "error" in data && data.error === code;
}
